// extracted by mini-css-extract-plugin
export var box = "_46-0";
export var check = "_46-1";
export var checkboxButton = "_46-6";
export var checkboxGroup = "_46-5";
export var disabled = "_46-7";
export var ghost = "_46-9";
export var input = "_46-2";
export var label = "_46-4";
export var normal = "_46-8";
export var uncheck = "_46-3";